import React from 'react';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';

import configurationStore from '../stores/configuration-store';
import facetStore from '../stores/item-preselection-facet-store';
import actions from '../actions';

import Wizard from './wizard';

const l = configurationStore.getLocalization.bind(configurationStore);
const ID = 'model';

export default createReactClass({

	displayName: 'ModelWizard',

	mixins: [
		Reflux.listenTo(facetStore, 'onFacetChange', 'onFacetChange')
	],

	getInitialState() {
		return {
			facets: [],
			active: true
		};
	},

	onFacetChange(data) {
		this.setState({facets: data.facets});
	},

	onSelectProperty(facet, property) {
		actions.selectProperty(facet, property);
		actions.selectModel();
	},

	render() {
		const attributes = {
			id: ID,
			title: l('chooseProduct'),
			subtitle: l('chooseProductSub'),
			facets: this.state.facets,
			hideTitle: true,
			inlineFacets: true,
			slider: false,
			active: this.state.active,
			isAccessory: false,
			onSelectProperty: this.onSelectProperty,
			topBorder: false
		};

		return (
			<Wizard {...attributes} />
		);
	}
});
